import React, {useEffect, useState} from 'react';
import {useResizeObserver} from "../../../hooks/useResizeObserver";
import {GridPaginationModel} from "@mui/x-data-grid-pro";
import _ from "lodash";
import {useNavigate, useSearchParams} from "react-router-dom";
import {FilteredSearch, addToUrlParams} from "@dreebit-registry/vsm-microservice-components";
import {AddRounded} from "@mui-symbols-material/w300";
import {Button} from "@mui/material";
import {useTranslation} from "react-i18next";
import AttributesTable from "../../../components/AttributesTable";
import CreateAttributeModal from "../../../components/AttributesTable/createAttributeModal";

interface Props {

}

const AttributeListScreen = (_props: Props) => {
    const {t} = useTranslation();

    const navigate = useNavigate();
    const [ref, filterHeight] = useResizeObserver();

    const [createAttributeModalOpen, setCreateAttributeModalOpen] = React.useState(false);
    const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

    const showEnvBanner = process.env.REACT_APP_SHOW_TESTING_BANNER === "true"
    const tableHeight = viewportHeight
        - filterHeight
        - (showEnvBanner ? 40 : 0) // Test Env Banner
        - 63 // Header
        - 35 // Padding from content

    const [urlParams, setUrlParams] = useSearchParams();

    // 'shortName' is the only reliable search field the backend supports for
    // property definitions ('preferredName'/'alias' silently match nothing).
    const searchFields = ['shortName']

    const [searchParams, setSearchParams] = useState({
        query: urlParams.get('query') || '',
        fields: searchFields
    })

    const onDebouncedSearch = _.debounce((values) => {
        setSearchParams({...values, fields: searchFields});
        addToUrlParams(urlParams, values, setUrlParams);
    }, 700);

    useEffect(() => {
        const handleResize = () => {
            setViewportHeight(window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <div
                ref={ref}
                className={'flex-row'}
                style={{justifyContent: 'space-between', alignItems: 'center', padding: '8px 8px 13px 8px'}}
            >
                <FilteredSearch
                    value={searchParams.query}
                    defaultFields={searchFields}
                    onSearch={onDebouncedSearch}
                />
                <Button
                    variant="contained"
                    startIcon={<AddRounded/>}
                    onClick={() => setCreateAttributeModalOpen(true)}
                >
                    {t('Add')}
                </Button>
            </div>
            <AttributesTable
                height={tableHeight}
                searchParams={searchParams}
                urlParams={urlParams}
                onChangePagination={(newPaginationModel: GridPaginationModel) => {
                    if (newPaginationModel) {
                        addToUrlParams(urlParams, newPaginationModel, setUrlParams)
                    }
                }}
                onOpenAttribute={(id) => navigate(`/configurations/attributes/${id}`)}
            />
            {createAttributeModalOpen && <CreateAttributeModal
                open={createAttributeModalOpen}
                onClose={() => setCreateAttributeModalOpen(false)}
            />}
        </>
    );
};

export default AttributeListScreen;


